import React, { useState, useEffect } from "react";
import { Button, Row, Col, Carousel } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useLogin } from "../../context/LoginContext";
import { useCourse } from "../../context/CourseContext";

export default function CommanTopBanner() {
    const { userCourse } = useCourse();
    const navigate = useNavigate();
    const { user } = useLogin();
    const [totalDraftCourse, setTotalDraftCourse] = useState(0);
    useEffect(() => {
        if (user?.selectedRole === 'approver') {
            const draftCourses = userCourse.filter(course => course.status === 'draft');//|| course.status === 'rejected'
            setTotalDraftCourse(draftCourses.length);
        }
    }, [userCourse, user?.selectedRole]);
    const createCourse = <Button className="green-grad-btn my-2 me-2" onClick={() => { navigate('/createcourse'); }} title="Create Course">Create Course</Button>;
    const approveCourses = <Button className="blue-grad-btn my-2 me-2" onClick={() => { navigate('/allcourses'); }} title="Approve Courses">Approve Courses <span className='notification-count'><sup>{totalDraftCourse>0?totalDraftCourse:0}</sup></span></Button>;
    const assignCourse = <Button className="purple-grad-btn my-2 me-2" onClick={() => { navigate('/assigncourse'); }} title="Assign Course">Assign Course</Button>;

    return (
        <Col lg={12} className="d-none d-lg-block">
            {user?.selectedRole !== 'viewer' ?
                <Row className="p-relative h304">
                    {user?.selectedRole === 'approver' && (
                        <Col md={12} className="text-center new-coursebtn green-gradient-bg">
                            <h6 className="fw-700" style={{ marginBottom: '1rem' }}>Let’s get started—create and approve your courses!</h6>
                            {createCourse}
                            {approveCourses}
                            {assignCourse}
                            <div className="mb-2 ms-1 small py-1" style={{ color: '#673417' }}>Build, Validate, and Share Your Learning Library<br />(From Seed to Harvest: Cultivate, Nurture, and Share Your Course)</div>
                        </Col>
                    )}
                    {user?.selectedRole === 'creater' && (
                        <Col md={12} className="text-center new-coursebtn green-gradient-bg">
                            <h6 className="fw-bold">Start bulding your courses library</h6>
                            {createCourse}
                            {assignCourse}
                            <div className="mb-2 ms-1 small fw-semibold py-1" style={{ color: '#673417' }}>Create your new course with videos, assessment & course materials <br />(Enjoy creating your course library)</div>
                        </Col>
                    )}
                </Row> :
                <Row className="slide-show">
                    <Carousel interval={null} className={"myAppCarousel2"} >
                        <Carousel.Item>
                            <img src="https://pmfby.amnex.co.in/pmfby/public/img/hero-slider-1.jpg" className="img-fluid" alt="PMFBY - LMS" />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img src="https://pmfby.amnex.co.in/pmfby/public/img/hero-slider-2.jpg" className="img-fluid" alt="PMFBY - LMS" />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img src="https://pmfby.amnex.co.in/pmfby/public/img/hero-slider-3.jpg" className="img-fluid" alt="PMFBY - LMS" />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img src="https://pmfby.amnex.co.in/pmfby/public/img/hero-slider-4.jpg" className="img-fluid" alt="PMFBY - LMS" />
                        </Carousel.Item>
                    </Carousel>
                </Row>
            }
        </Col>
    );
}
